/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiResultOfLinkedHashMapOfstringAndstring
 */
export interface ApiResultOfLinkedHashMapOfstringAndstring {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ApiResultOfLinkedHashMapOfstringAndstring
     */
    data?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfLinkedHashMapOfstringAndstring
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfLinkedHashMapOfstringAndstring
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfLinkedHashMapOfstringAndstring
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfLinkedHashMapOfstringAndstring
     */
    result?: ApiResultOfLinkedHashMapOfstringAndstringResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfLinkedHashMapOfstringAndstringResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfLinkedHashMapOfstringAndstringFromJSON(json: any): ApiResultOfLinkedHashMapOfstringAndstring {
    return ApiResultOfLinkedHashMapOfstringAndstringFromJSONTyped(json, false);
}

export function ApiResultOfLinkedHashMapOfstringAndstringFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfLinkedHashMapOfstringAndstring {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : json['data'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfLinkedHashMapOfstringAndstringToJSON(value?: ApiResultOfLinkedHashMapOfstringAndstring | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data,
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

